// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__32UMF","title":"Images90_title__qlK7v","images":"Images90_images__3fJcB"};